import {
  GRID_ROWS_PER_PAGE,
  SWITCH_VALUE,
  OOS_CASES,
} from '../../../constants';

export const initialState = {
  selectedComponent: OOS_CASES.multipleSearch, // variable for selected radio component
  oosCasesTotalRecords: 0,
  oosCasesResultsFound: true,
  oosCasesmultipleInputsValue: {
    accountingGroupCode: '',
    customerName: '',
    siteName: '',
    serviceLevelId: 0,
    reviewStatusId: 0,
    caseTypeId: 0,
    recordCount: GRID_ROWS_PER_PAGE.customers,
    pageIndex: 0,
  },
  isAccountingGroupsResultsFound: true,
  searchResult: [], // An array to store the search result
  loading: false,
  oosCasesLoading: false,
  inputError: null,
  displayError: false,
  accountingGroupModal: {
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.yes,
      isResellerGroup: SWITCH_VALUE.no,
    },
  },
  summaryPayload: {
    recordCount: GRID_ROWS_PER_PAGE.customers,
    pageIndex: 1,
  },
  summaryLoading: false,
  summaryData: [],
  totalNoOosCasesSummary: 0,
  summaryDataFound: true,
  singleFieldSearch: {
    caseId: '',
    RMA: '',
    workOrder: '',
  },
  caseId: 0,
  notesData: [],
  isNotesDataFound: true,
  fastFindData: false,
  caseItemsLoading: false,
  caseDetails: [],
  caseSiteDetails: [],
  oosCaseItems: [],
  caseItemHistoryLoading: false,
  caseItemCommentLoading: false,
  oosCaseItemComment: [],
  oosCaseItemsDataToSave: [],
  oosCaseItemsDataToSaveHistory: [],
  caseItemRMALoading: false,
  oosCaseItemRMA: [],
  oosChargeCode: [],
  oosSlectedItemRow: [],
  saveLoading: false,
  saveMessage: null,
  itemIndex: 0,
  chargeIndex: 0,
  loadingAccountingGroup: false,
}
